import { scoreFormatter } from "./scoreFormatter";

export interface IScoreboardRow {
  id: string;
  name: string;
  score: number;
  units: string;
}

export interface IRank {
  rank: number;
  className?: string;
}

export function ScoreboardRow(props: IScoreboardRow & IRank) {
  // Format the score or display a dash if NaN
  const formattedScore = isNaN(props.score) ? "-" : scoreFormatter(props.score);
  
  return (
    <tr className={`Table-Row ${props.className || ''}`}>
      <td className="Participant-Rank text">{props.rank + 1}</td>
      <td className="Participant-Name text">{props.name}</td>
      <td className="Participant-Score">
        <div className="metric">{formattedScore}</div>
      </td>
      <td className="Score-Units">{props.units}</td>
    </tr>
  );
}
